import React, { useState, useEffect, useCallback } from 'react';
import { useLabels } from 'wsm-common-data';
import { logger } from 'ws-scripts/modules/logger';

const MAP_VISIBILITY_PARAM = 'showMap';
const SHOW_MAP_LABEL_KEY = 'HIDE_MAP';
const HIDE_MAP_LABEL_KEY = 'SHOW_MAP';

const MapToggleButton = () => {
	const labels = useLabels();
	const [isMapVisible, setIsMapVisible] = useState(false);

	// Initialize state from URL parameter on component mount
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		setIsMapVisible(urlParams.get(MAP_VISIBILITY_PARAM) === 'true');
	}, []);

	// Update URL parameter when state changes
	const updateUrlParameter = useCallback((value) => {
		try {
			const url = new URL(window.location);
			url.searchParams.set(MAP_VISIBILITY_PARAM, value.toString());
			window.history.replaceState({}, '', url);

			// Notify ws-locations-search widget about the change
			window.dispatchEvent(new Event('showMapChange'));
		} catch (error) {
			logger.error(
				'MapToggleButton',
				'updateUrlParameter',
				'Failed to update URL parameter',
				error
			);
		}
	}, []);

	const handleToggle = (e) => {
		e.preventDefault();
		const newMapVisible = !isMapVisible;
		setIsMapVisible(newMapVisible);
		updateUrlParameter(newMapVisible);
	};

	return (
		<button
			className="btn btn-default mt-3"
			onClick={handleToggle}
			type="button"
			aria-pressed={isMapVisible}
			aria-label={isMapVisible ? 'Hide map view' : 'Show map view'}
		>
			{isMapVisible
				? labels.get(SHOW_MAP_LABEL_KEY) || 'Hide Map'
				: labels.get(HIDE_MAP_LABEL_KEY) || 'Show Map'}
		</button>
	);
};

export default MapToggleButton;
